import axios from "axios";
import config from "./config";

const BASE = `${config.url}/expenses/bills`;

function adminHeaders() {
  return { Authorization: `Basic ${process.env.REACT_APP_BASIC_AUTH}` };
}

export const BillsService = {
  async list(memberId, { status, month, year, limit } = {}) {
    const params = {};
    if (status) params.status = status;
    if (month) params.month = month;
    if (year) params.year = year;
    if (limit) params.limit = limit;
    const { data } = await axios.get(`${BASE}/${memberId}`, { params, headers: adminHeaders() });
    return data;
  },
  async get(memberId, id) {
    const { data } = await axios.get(`${BASE}/${memberId}/${id}`, { headers: adminHeaders() });
    return data;
  },
  async update(memberId, id, payload) {
    const { data } = await axios.patch(`${BASE}/${memberId}/${id}`, payload, { headers: adminHeaders() });
    return data;
  },
  async approve(memberId, id, overrides = {}) {
    const { data } = await axios.post(`${BASE}/${memberId}/${id}/approve`, overrides, { headers: adminHeaders() });
    return data;
  },
  async reject(memberId, id, reason) {
    const { data } = await axios.post(`${BASE}/${memberId}/${id}/reject`, { reason }, { headers: adminHeaders() });
    return data;
  },
};
